import Joi from 'joi'

export const schema = Joi.object({
  current: Joi.string().required().label('Senha atual').messages({
    'string.empty': 'Informe sua senha atual para continuar.',
    'any.required': 'Informe sua senha atual para continuar.',
  }),
  next: Joi.string().required(),
  confirmation: Joi.string().required().valid(Joi.ref('next')),
})
